import dashboardItemList from './dashboardItemList';
import SidebarNavList from './SidebarNavList';

export default function Sidebar() {
  // useEffect(() => {
  //   if (location.pathname.includes('home') && !!state.customerId) {
  //     refetchDashboard();
  //   }
  // }, [location.pathname, state.customerId]);

  return (
    <nav className={'left-menu'}>
      <SidebarNavList items={dashboardItemList} />
    </nav>
  );
}
